import http from '@/http/index'
let apiMaterials = process.env.VUE_APP_APIMATERIALS
let apiPersonal = process.env.VUE_APP_APIUSER
let apiJuri = process.env.VUE_APP_LOGINAPI
let apiLogin = process.env.VUE_APP_API_LOGIN
let option = { 
  headers: { 'Content-Type': 'application/x-www-form-urlencoded', platform:'pc' },
  withCredentials: true
}
const apiUser = {
  getUserInfo: () => http.get(apiPersonal + '/api/user/getCurrentUserInfoV2'),
  getArea: () => http.get(apiMaterials + '/index/getCurrentProvince'),
  createQrCode: () => http.get(apiPersonal + '/api/qrscan/createQrCode'), // 获取uuid
  queryQRCode: (uuid) => http.get(apiPersonal + '/api/qrscan/queryQRCode', uuid), // 获取二维码返回结果
  findSsoUrlList: data => http.get(`${apiJuri}/sync-ticket/v1/cookie/findSsoUrlList`, data, option),
  setCookie: data => http.get(`${data}`, {}, option),
  getJurisdiction: () => http.get(apiJuri + '/authentication/sv1/user'),
  logOut:() => http.get(apiLogin + '/logout'),//退出登录
}
export default apiUser
